module.exports = __webpack_public_path__ + "static/img/me.af7398f3.svg";